import { Theme } from "../../types";
import { CSSObject } from "@emotion/react";

export const customStyles = (
  theme: Theme
): { [key: string]: Record<string, CSSObject | string | number> } => ({
  customButton: {
    border: "none",
    color: theme.colorSchema.buttons.primary.text,
   // padding: "14px 20px",
    textAlign: "center",
    display: "inline-block",
    fontSize: "1rem",
    marginTop: "10px",
    cursor: "pointer",
    borderRadius: "25px",
    width: "100%",
    fontWeight: 700,
    height: "43px",
    transition: "background 0.3s ease, color 0.3s ease",
    background: `linear-gradient(to right, ${theme.colorSchema.buttons.primary.background[0]}, ${theme.colorSchema.buttons.primary.background[1]})`,
    "&:hover": {
      background: `linear-gradient(to right, ${theme.colorSchema.buttons.primary.background[1]}, ${theme.colorSchema.buttons.primary.background[0]})`,
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },

  loadingButton: {
    border: "none",
    textAlign: "center",
    display: "inline-block",
    marginTop: "10px",
    cursor: "pointer",
    borderRadius: "15px",
    width: "100%",
    maxWidth: "600px",
    boxShadow: "2px 2px 2px #898a8d",
    background: "linear-gradient(to right, #1D3AAB, #880098)",
    maxHeight: "43px",
  },

  loadingIcon: {
    width: "43px",
    height: "43px",
    margin: 0,
  },

  secondaryButton: {
    border: "1px solid",
    borderColor: theme.colorSchema.buttons.secondary.outline,
    color: theme.colorSchema.buttons.secondary.text,
    padding: "0px 20px",
    height: "43px",
    textAlign: "center",
    display: "inline-block",
    fontSize: "1rem",
    marginTop: "10px",
    cursor: "pointer",
    borderRadius: "25px",
    width: "100%",
    fontWeight: 700,
    transition: "background 0.3s ease, color 0.3s ease",
    background: theme.colorSchema.buttons.secondary.background,
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },

  
  outlinedButton: {
    border: `2px solid ${theme.colorSchema.colors.mainText}`, // or theme.colorSchema.buttons.danger.border
    color: theme.colorSchema.colors.mainText, // or theme.colorSchema.buttons.danger.text
    background: "transparent",
    padding: "0px 20px",
    height: "43px",
    textAlign: "center",
    display: "inline-block",
    fontSize: "1rem",
    marginTop: "10px",
    cursor: "pointer",
    borderRadius: "25px",
    width: "100%",
    fontWeight: 700,
    transition: "all 0.3s ease",
    // "&:hover": {
    //   border: `2px solid red`,
    //   color: "red",
    // },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },
  deleteButton: {
    border: `2px solid red`,
    color: "red",
    background: "transparent",
    padding: "0px 20px",
    height: "43px",
    textAlign: "center",
    display: "inline-block",
    fontSize: "1rem",
    marginTop: "10px",
    cursor: "pointer",
    borderRadius: "25px",
    width: "100%",
    fontWeight: 700,
    transition: "all 0.3s ease",
    // "&:hover": {
    //   border: `2px solid red`,
    //   color: "red",
    // },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },

  loadingDeleteButton: {
    border: `2px solid ${theme.colorSchema.colors.mainText}`,
    color: theme.colorSchema.colors.mainText,
    background: "transparent",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 18px",
    marginTop: "10px",
    borderRadius: "25px",
    width: "100%",
    maxHeight: "43px",
    cursor: "pointer",
    fontWeight: 700,
    "& svg": {
      marginRight: "8px",
      animation: "spin 1s linear infinite",
    },
    "@keyframes spin": {
      from: { transform: "rotate(0deg)" },
      to: { transform: "rotate(360deg)" },
    },
  },
});
